"use client";

import Link from "next/link";
import { buildPlaceDetailPath } from "@/constants/routes";
import { getOpenStatusText } from "@/utils/place-business-hours";

/**
 * 플레이 상세(모달) 오른쪽의 「이 가게」 카드.
 *
 * 왜 만들었나: 지금 우리 플레이는 대부분 댓글이 0이라 모달 오른쪽 약 480px 이 늘 비어 있었다.
 * 영상은 좋은데 첫인상이 「비어 있는 서비스」가 됐다. 그 자리에 영상 → 가게로 가는 길을 놓는다.
 * (2026-08-11 데스크톱 검수 ②, 대표님 확정 「나」)
 *
 * ⚠️ 댓글이 **없을 때만** 보인다. 댓글이 달리기 시작하면 그 자리는 댓글이 쓴다.
 * ⚠️ 영업 상태는 `utils/place-business-hours` 를 쓴다 — 장소 상세와 같은 계산이라야 한다.
 */
const formatReviewCount = (place) => {
  const count = Number(place?.numberOfVisitorReviews || 0);
  if (!Number.isFinite(count) || count <= 0) return "";
  return `리뷰 ${Math.round(count).toLocaleString()}`;
};

const ContentPlaceCard = ({ place }) => {
  if (!place) return null;

  const name = place?.name;
  if (!name) return null;

  const address = place?.address || place?.old_address || "";
  const category = place?.type || place?.subcategory || place?.category || "";
  const reviews = formatReviewCount(place);
  const meta = [category, reviews].filter(Boolean).join(" · ");
  const openStatus = getOpenStatusText(place);
  const href = buildPlaceDetailPath(place);

  return (
    <div className="w-full">
      <p className="text-t-label font-bold text-ink-45 mb-2.5">이 가게</p>

      <div className="rounded-card border border-hairline p-4">
        <p className="text-t-item font-extrabold text-ink leading-snug">{name}</p>

        {meta ? (
          <p className="text-t-meta text-ink-70 mt-1.5">{meta}</p>
        ) : null}

        {address ? (
          <p className="text-t-meta text-ink-70 mt-0.5">{address}</p>
        ) : null}

        {openStatus ? (
          <p className="text-t-meta font-semibold text-open_now mt-2">{openStatus}</p>
        ) : null}

        {href ? (
          <Link
            href={href}
            className="mt-3.5 flex w-full items-center justify-center rounded-chip bg-ink px-4 py-2.5 text-t-sub font-bold text-surface"
          >
            가게 보기
          </Link>
        ) : null}
      </div>
    </div>
  );
};

export default ContentPlaceCard;
